import { PayloadAction } from "@reduxjs/toolkit";
import { LocationState } from "@/redux/slice/location/types/LocationState";
import { CurrentLocationUpdatedStatus } from "@/redux/slice/location/enums/CurrentLocationUpdatedStatus";
import addressListAdapter from "@/redux/slice/location/adapters/addressList";
import { ThunkResolvedStatus } from "@/libs/enum/ThunkResolvedStatus";
import { PatientAddress } from "@/redux/slice/location/types/PatientAddress";
import { SpecifiedLocation } from "@/redux/slice/location/types/SpecifiedLocation";

const syncLocationActionReducers = {
  updateSpecifiedLocation(state: LocationState, action: PayloadAction<SpecifiedLocation>) {
    const specifiedLocation = action.payload;
    if (specifiedLocation?.latitude) state.latitude = specifiedLocation.latitude;
    if (specifiedLocation?.longitude) state.longitude = specifiedLocation.longitude;
    if (specifiedLocation?.country) state.country = specifiedLocation.country;
    if (specifiedLocation?.city) state.city = specifiedLocation.city;
    if (specifiedLocation?.state) state.state = specifiedLocation.state;
    if (specifiedLocation?.pincode) state.pincode = specifiedLocation.pincode;
    if (specifiedLocation?.tatInput) state.tatInput = specifiedLocation.tatInput;
  },
  updateIsAddressListUpdated(state: LocationState, action: PayloadAction<boolean>) {
    state.isAddressListUpdated = action.payload;
  },
  updateIsAddressUpdated(state: LocationState, action: PayloadAction<boolean>) {
    state.isAddressUpdated = action.payload;
  },
  updateAddressLoading(state: LocationState, action: PayloadAction<boolean>) {
    state.addressLoading = action.payload;
  },
  updateCurrentAddressId(state: LocationState, action: PayloadAction<string>) {
    state.currentAddressId = action.payload;
  },
  updatePickAddressDialogOpen(state: LocationState, action: PayloadAction<boolean>) {
    state.pickAddressDialogOpen = action.payload;
  },
  updateAddAddressDialogOpen(state: LocationState, action: PayloadAction<boolean>) {
    state.addAddressDialogOpen = action.payload;
  },
  updateEditAddressId(state: LocationState, action: PayloadAction<string>) {
    state.editAddressId = action.payload;
  },
  updateShowPincodeModal(state: LocationState, action: PayloadAction<boolean>) {
    state.showPincodeModal = action.payload;
  },
  updateIsPincodeServiceable(state: LocationState, action: PayloadAction<boolean>) {
    state.isPincodeServiceable = action.payload;
  },
  updateHeaderPincodeError(state: LocationState, action: PayloadAction<boolean>) {
    state.headerPincodeError = action.payload;
  },
  updateAddressList(state: LocationState, action: PayloadAction<PatientAddress[]>) {
    addressListAdapter.setAll(state.addressList, action.payload);
  },
  updatePlaceDetailsStatus(state: LocationState, action: PayloadAction<ThunkResolvedStatus>) {
    state.thunkStatus.placeDetails = action?.payload;
  },
  updateCurrentLocationUpdated(state: LocationState, action: PayloadAction<CurrentLocationUpdatedStatus>) {
    state.currentLocationUpdated = action?.payload;
  },
  updateOpenChangeAddressPopup(state: LocationState, action: PayloadAction<boolean>) {
    state.openChangeAddressPopup = action.payload;
  },
  updateIsAlertOpen(state: LocationState, action: PayloadAction<boolean>) {
    state.isAlertOpen = action.payload;
  },
  updateIsGreyBackground(state: LocationState, action: PayloadAction<boolean>) {
    state.isGreyBackground = action.payload;
  },
  updateAlertMessage(state: LocationState, action: PayloadAction<string>) {
    state.alertMessage = action.payload;
  },
  updateFetchingSearchPlaceSuggestions(state: LocationState, action: PayloadAction<ThunkResolvedStatus>) {
    state.thunkStatus.fetchingSearchPlaceSuggestions = action?.payload;
  },
  updateUserFromApp(state: LocationState, action: PayloadAction<boolean>) {
    state.userFromApp = action.payload;
  },
  updateUserFromAppFooter(state: LocationState, action: PayloadAction<boolean>) {
    state.userFromAppFooter = action.payload;
  },
};
export default syncLocationActionReducers;
